const methods = {
    // Obtenemos las operaciones filtradas por día
    async fetchData() {
        this.loading = true;
        try {
            const dateSelected = this.$moment(this.item.date).format('YYYY-MM-DD');
            const resOperations = await this.$accountsService.operationsMismatchesDate(dateSelected);
            const { operations_mismatches } = resOperations.data;
            this.items = operations_mismatches || [];
            this.loading = false;
        } catch (error) {
            console.error(error);
        }
    },
    modalWarning(type, item) {
        this.actionSelected = type;
        this.mismatchesItemSelected = [];
        item.forEach(operation => {
            operation.actionData.source = 'ONLINE';
            operation.actionData._origin = 'tab-date-details';
            this.mismatchesItemSelected.push(operation.actionData);
        });
        this.$root.$emit('showModalWarningAction', true);
    },

    /**
     * Se fusionan las operaciones y se cambian a estado FINALIZADO,
     * la operación deberá estar en estado RD_SENT sino fallaría
     * @param {*} payload Operación
     */
    async createFusion(payload) {
        this.loading = true;
        this.$root.$emit('showModalWarningAction', false);
        const operation = payload[0];
        try {
            const payloadFusion = {
                uuid_daily_summary: operation.uuid_daily_summary,
                match: true,
                uuid_mismatched_operation: operation.uuid_mismatched_operation,
                nav_date: operation.nav_date,
                nav: operation.nav,
                real_surplus_drop_in_value: operation.real_surplus_drop_in_value,
                key_product: operation.key_product,
                key_operation_type: operation.key_operation_type,
                shares: operation.shares,
                withholding: operation.withholding,
                commission: operation.commission,
                gross_amount: operation.gross_amount,
                net_amount: operation.net_amount
            };
            await this.$operationsService.updateOperation(operation.uuid, payloadFusion);
            await this.$operationsService.changeOperationStatus(operation.uuid, {
                status: 'FINALIZED'
            });
            this.loading = false;
            this.$toast.success(`Fusión realizada`, `La operación se ha fusionado con éxito.`);
            this.$root.$emit('refreshMonitor');
            this.fetchData();
        } catch (error) {
            this.$toast.error(`Fusión fallida`, `No se ha podido fusionar la operación.`);
            this.$root.$emit('refreshMonitor');
            this.fetchData();
        }
    },

    /**
     * Se crea la operación en estado a "FINALIZADO"
     * @param {*} payload Operación
     */
    async addOperation(payload) {
        this.loading = true;
        this.$root.$emit('showModalWarningAction', false);
        const operation = payload[0];
        try {
            operation.uuid = undefined;
            operation.source = 'ONLINE';
            await this.$operationsService.createOperation(operation);
            this.loading = false;
            this.$toast.success(`Operación añadida`, `La operación se ha añadido con éxito.`);
            this.$root.$emit('refreshMonitor');
            this.fetchData();
        } catch (error) {
            this.$toast.error(`Operación fallida`, `No se ha podido crear la operación.`);
            this.$root.$emit('refreshMonitor');
            this.fetchData();
        }
    },

    /**
     * Se crea la operación en estado a "FINALIZADO"
     * @param {*} payload Operación
     */
    async addFusionAllOperations(payload) {
        this.loading = true;
        this.$root.$emit('showModalWarningAction', false);
        try {
            await this.$operationsService.createOperationsBulk({ operations: payload });
            this.loading = false;
            this.$toast.success(`Operaciones añadidas`, `La operaciones se han añadido/fusionado con éxito.`);
            this.$root.$emit('refreshMonitor');
            this.fetchData();
        } catch (error) {
            this.$toast.error(`Error`, `Error al añadir/fusionar operaciones`);
            this.$root.$emit('refreshMonitor');
            this.fetchData();
        }
    },

    async addFusionSelectedOperations(payload) {
        this.loading = true;
        this.$root.$emit('showModalWarningAction', false);
        try {
            await this.$operationsService.createOperationsBulk({ operations: payload });
            this.loading = false;
            this.$toast.success(`Operaciones añadidas`, `La operaciones se han añadido/fusionado con éxito.`);
            this.$root.$emit('refreshMonitor');
            this.fetchData();
        } catch (error) {
            this.$toast.error(`Error`, `Error al añadir/fusionar operaciones`);
            this.$root.$emit('refreshMonitor');
            this.fetchData();
        }
    },

    selectMissmacthOperationCheckbox(state, item) {
        if (state) {
            this.selectedItems.push(item);
        } else {
            this.selectedItems = this.selectedItems.filter(sItem => sItem.uuid !== item.uuid);
        }
    }
};

export default methods;
